(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Route', Route);

    Route.$inject = ['$resource'];

    function Route ($resource) {
        var resourceUrl =  'api/routes/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByMedication': {method: 'GET', isArray: true, url: 'api/routes/by-medication/:id'},
            'findAllByCorporation': { url: 'api/routes/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();
